import axios from '../axios';

export const show = () => {
  return axios.get('/general-information?lang=pl');
};

export const submit = (payload) => {
  return axios.post('/general-information?lang=pl', payload);
};
